module.exports = __webpack_public_path__ + "img/bbb1.e009700f.gif";